module.exports = __webpack_public_path__ + "static/media/Shade5.ef19a2af.jpg";